/* Pelage Co. — cart drawer: AJAX add-to-cart, quantity/remove, free-shipping progress bar. */
(function () {
  if (window.pelageCartDrawerInit) return;
  window.pelageCartDrawerInit = true;

  var drawer = document.getElementById('CartDrawer');
  if (!drawer) return;

  var lastFocused = null;
  var busy = false;
  var dirty = false;
  var pendingChange = null;

  /* ---------- money formatting (Shopify standard money_format placeholders) ---------- */
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = typeof precision === 'number' ? precision : 2;
    thousands = thousands || ',';
    decimal = decimal || '.';
    if (isNaN(number) || number == null) number = 0;
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.');
    var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents) {
    var format = (window.Pelage && window.Pelage.moneyFormat) || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);
    if (!match) return format;
    var value;
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- open / close with focus handling ---------- */
  function onKeydown(e) {
    if (e.key === 'Escape') {
      closeDrawer();
      return;
    }
    if (e.key === 'Tab') {
      var focusable = drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function openDrawer() {
    lastFocused = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cart-drawer-open');
    var closeBtn = drawer.querySelector('.cart-drawer__close');
    if (closeBtn) closeBtn.focus();
    document.addEventListener('keydown', onKeydown);
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cart-drawer-open');
    document.removeEventListener('keydown', onKeydown);
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  /* ---------- header cart count badge ---------- */
  function updateHeaderCount(count) {
    var cartLink = document.querySelector('.site-header__cart');
    if (!cartLink) return;
    var badge = cartLink.querySelector('.site-header__cart-count');
    if (count > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'site-header__cart-count';
        cartLink.appendChild(badge);
      }
      badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  }

  /* ---------- free shipping progress bar ---------- */
  function updateShipping(cartData) {
    var wrap = drawer.querySelector('[data-cart-drawer-shipping]');
    var threshold = (window.Pelage && window.Pelage.freeShippingThreshold) || 0;
    if (!threshold || cartData.item_count === 0) {
      wrap.hidden = true;
      return;
    }
    wrap.hidden = false;
    var fillEl = drawer.querySelector('[data-cart-drawer-shipping-fill]');
    var textEl = drawer.querySelector('[data-cart-drawer-shipping-text]');
    var subtotal = cartData.total_price;
    var pct = Math.min(100, (subtotal / threshold) * 100);
    fillEl.style.width = pct + '%';
    if (subtotal >= threshold) {
      fillEl.classList.add('is-complete');
      textEl.innerHTML = '🎉 You&rsquo;ve unlocked <strong>free shipping!</strong>';
    } else {
      fillEl.classList.remove('is-complete');
      var remaining = threshold - subtotal;
      textEl.innerHTML = 'Add <strong>' + formatMoney(remaining) + '</strong> more for <strong>free shipping!</strong>';
    }
  }

  /* ---------- render cart items into the drawer ---------- */
  function itemRowHtml(item) {
    var variantLine =
      item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-drawer__item-variant">' + escapeHtml(item.variant_title) + '</div>'
        : '';
    var img = item.image
      ? '<img src="' + item.image + '" alt="" loading="lazy">'
      : '';
    return (
      '<div class="cart-drawer__item" data-cart-drawer-item data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-drawer__item-image" tabindex="-1" aria-hidden="true">' + img + '</a>' +
        '<div class="cart-drawer__item-details">' +
          '<div class="cart-drawer__item-top">' +
            '<div class="cart-drawer__item-info">' +
              '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHtml(item.product_title) + '</a>' +
              variantLine +
            '</div>' +
            '<div class="cart-drawer__item-price">' + formatMoney(item.final_price) + '</div>' +
          '</div>' +
          '<div class="cart-drawer__item-bottom">' +
            '<div class="cart-drawer__item-qty">' +
              '<button type="button" class="cart__qty-btn" data-cart-drawer-qty-btn data-step="-1" aria-label="Decrease quantity of ' + escapeHtml(item.product_title) + '">&minus;</button>' +
              '<input type="number" class="cart-drawer__item-qty-input" data-cart-drawer-qty-input value="' + item.quantity + '" min="0" inputmode="numeric" aria-label="Quantity of ' + escapeHtml(item.product_title) + '">' +
              '<button type="button" class="cart__qty-btn" data-cart-drawer-qty-btn data-step="1" aria-label="Increase quantity of ' + escapeHtml(item.product_title) + '">+</button>' +
            '</div>' +
            '<button type="button" class="cart-drawer__item-remove" data-cart-drawer-remove aria-label="Remove ' + escapeHtml(item.product_title) + '">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function renderCart(cartData) {
    var list = drawer.querySelector('[data-cart-drawer-list]');
    var empty = drawer.querySelector('[data-cart-drawer-empty]');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var subtotalEl = drawer.querySelector('[data-cart-drawer-subtotal]');

    if (cartData.item_count === 0) {
      list.innerHTML = '';
      empty.hidden = false;
      footer.hidden = true;
    } else {
      empty.hidden = true;
      footer.hidden = false;
      list.innerHTML = cartData.items.map(itemRowHtml).join('');
    }
    subtotalEl.textContent = formatMoney(cartData.total_price);
    updateShipping(cartData);
    updateHeaderCount(cartData.item_count);
  }

  function showDrawerError() {
    var list = drawer.querySelector('[data-cart-drawer-list]');
    var existing = list.querySelector('.cart-drawer__error');
    if (existing) return;
    var el = document.createElement('p');
    el.className = 'cart-drawer__error form-error';
    el.setAttribute('role', 'alert');
    el.textContent = "Couldn't update your cart. Please try again.";
    list.prepend(el);
  }

  /* ---------- network helpers ---------- */
  function fetchCart() {
    return fetch(window.Pelage.routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.json();
    });
  }

  function setDrawerBusy(state) {
    drawer.classList.toggle('is-updating', state);
  }

  function changeLine(key, quantity) {
    if (busy) {
      dirty = true;
      pendingChange = { key: key, quantity: quantity };
      return;
    }
    busy = true;
    setDrawerBusy(true);
    fetch(window.Pelage.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: parseInt(quantity, 10) || 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart change failed: ' + r.status);
        return r.json();
      })
      .then(function (data) {
        renderCart(data);
      })
      .catch(function () {
        showDrawerError();
      })
      .then(function () {
        busy = false;
        setDrawerBusy(false);
        if (dirty) {
          dirty = false;
          var next = pendingChange;
          pendingChange = null;
          if (next) changeLine(next.key, next.quantity);
        }
      });
  }

  /* ---------- add to cart (intercepts the product page form) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('form.shopify-product-form, form[data-type="add-to-cart-form"]')) return;
    if (!form.querySelector('input[name="id"]')) return;
    e.preventDefault();

    var submitBtn = form.querySelector('.product__add-to-cart');
    var originalText = submitBtn ? submitBtn.textContent : '';
    var originalDisabled = submitBtn ? submitBtn.disabled : false;
    var errorEl = form.querySelector('[data-cart-drawer-form-error]');
    if (errorEl) errorEl.hidden = true;
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    }

    var formData = new FormData(form);
    fetch(window.Pelage.routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          throw new Error((result.data && result.data.description) || 'Could not add this item to your cart.');
        }
        return fetchCart();
      })
      .then(function (cartData) {
        renderCart(cartData);
        openDrawer();
      })
      .catch(function (err) {
        if (errorEl) {
          errorEl.textContent = err.message;
          errorEl.hidden = false;
        }
      })
      .then(function () {
        if (submitBtn) {
          submitBtn.disabled = originalDisabled;
          submitBtn.textContent = originalText;
        }
      });
  });

  /* ---------- header cart icon opens the drawer ---------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    var cartIcon = e.target.closest('.site-header__cart');
    if (cartIcon && e.button === 0 && !e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey) {
      e.preventDefault();
      fetchCart()
        .then(function (data) {
          renderCart(data);
          openDrawer();
        })
        .catch(function () {
          window.location.href = cartIcon.href;
        });
      return;
    }

    var qtyBtn = e.target.closest('[data-cart-drawer-qty-btn]');
    if (qtyBtn) {
      var row = qtyBtn.closest('[data-cart-drawer-item]');
      var input = row.querySelector('[data-cart-drawer-qty-input]');
      var v = parseInt(input.value, 10);
      if (isNaN(v)) v = 0;
      v += parseInt(qtyBtn.dataset.step, 10);
      v = v < 0 ? 0 : v;
      input.value = v;
      changeLine(row.dataset.key, v);
      return;
    }

    var removeBtn = e.target.closest('[data-cart-drawer-remove]');
    if (removeBtn) {
      var removeRow = removeBtn.closest('[data-cart-drawer-item]');
      changeLine(removeRow.dataset.key, 0);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-cart-drawer-qty-input]')) {
      var row = e.target.closest('[data-cart-drawer-item]');
      changeLine(row.dataset.key, e.target.value);
    }
  });
})();
